import { render, staticRenderFns } from "./OnlCgformAutoList.vue?vue&type=template&id=30812c4c&scoped=true&"
import script from "./OnlCgformAutoList.vue?vue&type=script&lang=js&"
export * from "./OnlCgformAutoList.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgformAutoList.vue?vue&type=style&index=0&id=30812c4c&scoped=true&lang=css&"
import style1 from "./OnlCgformAutoList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30812c4c",
  null
  
)

export default component.exports